import React from "react";
import { Flex, Col, Row } from "antd";
import { Link } from "react-router-dom";
import { ReactComponent as Facebook } from "../assets/icons/Facebook.svg";
import { ReactComponent as Instagram } from "../assets/icons/Instagram.svg";
import { ReactComponent as Twitter } from "../assets/icons/Twitter.svg";
import { ReactComponent as Youtube } from "../assets/icons/Youtube.svg";
import { ReactComponent as Linkedin } from "../assets/icons/Linkedin.svg";
import StorageService from "../utils/storage";
import { footerMenuQuery } from "../utils/query";
import { useQuery } from "@apollo/client";
import Flags from "../assets/images/flags.png";

export default function AppFooter() {
    const organisation = StorageService.getItem("organisation");
    const logo = StorageService.getItem("logo");

    const { data } = useQuery(footerMenuQuery, {
        variables: {
            id: StorageService.getItem("organisationBusableId"),
        },
    });

    return (
        <footer className="AppFooter">
            <div className="SiteFooter">
                <div className="AppContainer">
                    <Row>
                        <Col lg={6} style={{paddingRight: 30}}>
                            <Flex justify="space-between" gap="20px" vertical>
                                <Link to="/">
                                    <img src={logo} height={48} alt="" />
                                </Link>
                                <p>{organisation?.WebsiteBuilder?.bio}</p>
                                <ul className="SocialIcons">
                                    {organisation?.WebsiteBuilder?.facebook_url && (
                                        <li>
                                            <Link to={organisation?.WebsiteBuilder?.facebook_url} target="_blank">
                                                <Linkedin />
                                            </Link>
                                        </li>
                                    )}
                                    {organisation?.WebsiteBuilder?.instagram_url && (
                                        <li>
                                            <Link to={organisation?.WebsiteBuilder?.instagram_url} target="_blank">
                                                <Instagram />
                                            </Link>
                                        </li>
                                    )}
                                    {organisation?.WebsiteBuilder?.twitter_url && (
                                        <li>
                                            <Link to={organisation?.WebsiteBuilder?.twitter_url} target="_blank">
                                                <Twitter />
                                            </Link>
                                        </li>
                                    )}
                                    {organisation?.WebsiteBuilder?.youtube_url && (
                                        <li>
                                            <Link to={organisation?.WebsiteBuilder?.youtube_url} target="_blank">
                                                <Youtube />
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </Flex>
                        </Col>
                        <Col lg={18}>
                            <Row>
                                {data?.wbMenus?.data[0]?.attributes?.menu?.map((menu) => (
                                    <Col key={menu.id} xs={12} lg={6}>
                                        <div className="FooterLinks">
                                            {!menu.hideName && <h4>{menu.name}</h4>}
                                            <ul>
                                                {menu?.menu?.map((submenu) => (
                                                    <li key={submenu.id}>
                                                        <Link to={submenu.url} target={submenu.url.startsWith("/") ? "_self" : "_blank"}>
                                                            {submenu.name}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="CopyFooter">
                <div className="AppContainer">
                    <small>
                        &copy; Copyright 2024 Picton Buslines. All rights reserved. <Link to="/privacy-policy">Privacy policy</Link>
                    </small>
                    <small>
                        Website powered by{" "}
                        <a href="https://busable.app" target="_blank" rel="noreferrer">
                            Busable
                        </a>
                    </small>
                </div>
            </div>
            <div className="AppContainer">
                    <div style={{textAlign: 'center', fontSize: 15, maxWidth: 750, width: '100%', margin: 'auto', color: '#677085', lineHeight: '25px'}}>Picton Buslines acknowledges the Traditional Owners of the land in Wollondilly, the Dharawal and Gundungurra peoples and pay our respects to Elders past, present and emerging. We celebrate the stories, culture and traditions of Aboriginal and Torres Strait Islander Elders of all communities who also work and live on this land.<br/><img src={Flags} height={50} alt="" style={{marginTop: 20}} /></div>
                </div>
        </footer>
    );
}
